import OperationsView from "./operations-view.jsx";
import useOperationsTable from "./useOperationsTable.js";

export { useOperationsTable };
export default OperationsView;